var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VRow',{staticClass:"data-row"},[_c('VCol',_vm._b({staticClass:"label-col semi-bold"},'VCol',_vm.labelVColAttrs,false),[_vm._t("label-icon"),_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label)+":")]})],2),_c('VCol',_vm._b({staticClass:"value-col"},'VCol',_vm.valueVColAttrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }